
export const getLastTickets = async () => {
    const resp = await fetch('http://localhost:8080/last-tickets')
    const data = await resp.json()

    return data.last_tickets
}